export class AmountToWord {

  static ChuSo = [" không", " một", " hai", " ba", " bốn", " năm", " sáu", " bảy", " tám", " chín"];
  static Tien = ["", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ"];

  static changeType(type) {
    let format;
    switch (type) {
      case 'VND':
        format = ' đồng';
        break;
      case 'USD':
        format = ' đô la Mỹ';
        break;
      case 'JPY':
        format = ' yên Nhật';
        break;
      case 'AUD':
        format = ' đô la Úc';
        break;
      case 'CAD':
        format = ' đô la Canada';
        break;
      case 'GBP':
        format = ' bảng Anh';
        break;
      case 'SGD':
        format = ' đô la Singapore';
        break;
      case 'RUB':
        format = ' rúp Nga';
        break;
      case 'CNY':
        format = ' nhân dân tệ';
        break;
      case 'HKD':
        format = ' đô la Hồng Công';
        break;
      case 'KRW':
        format = ' won Hàn Quốc';
        break;
      case 'EUR':
        format = ' euro';
        break;
      default:
        format = type;
        break;
    }
    return format;
  }

  static DocSo3ChuSo(baso: number) {
    let tram;
    let chuc;
    let donvi;
    let KetQua = "";
    tram = parseInt(String(baso / 100));
    chuc = parseInt(String((baso % 100) / 10));
    donvi = baso % 10;
    if (tram === 0 && chuc === 0 && donvi === 0) return "";
    if (tram !== 0) {
      KetQua += this.ChuSo[tram] + " trăm";
      if ((chuc === 0) && (donvi !== 0)) KetQua += " linh";
    }
    if ((chuc !== 0) && (chuc !== 1)) {
      KetQua += this.ChuSo[chuc] + " mươi";
      if ((chuc === 0) && (donvi !== 0)) KetQua = KetQua + " linh";
    }
    if (chuc === 1) KetQua += " mười";
    switch (donvi) {
      case 1:
        if ((chuc !== 0) && (chuc !== 1)) {
          KetQua += " mốt";
        } else {
          KetQua += this.ChuSo[donvi];
        }
        break;
      case 4:
        if ((chuc !== 0) && (chuc !== 1)) {
          KetQua += " tư";
        } else {
          KetQua += this.ChuSo[donvi];
        }
        break;
      case 5:
        if (chuc === 0) {
          KetQua += this.ChuSo[donvi];
        } else {
          KetQua += " lăm";
        }
        break;
      default:
        if (donvi !== 0) {
          KetQua += this.ChuSo[donvi];
        }
        break;
    }
    return KetQua;
  }

  static DocTienBangChu(SoTien, type, config: any) {
    let Tien4 = ["", " nghìn", " triệu", " tỷ", " nghìn", " triệu"];
    let strTachPhanSauDauPhay = [];
    let opNguyen = type;
    let opThapphan = type == "VND" ? " đồng" : " xu";
    let optionAnd = type == "USD" ? " và " : " và ";

    if (SoTien.includes(".") || SoTien.includes(",")) {
      strTachPhanSauDauPhay = SoTien.split('.');
      if (Number(strTachPhanSauDauPhay[1].toString()) <= 0) {
        return (this.DocTienBangChu(strTachPhanSauDauPhay[0], opNguyen, {read: ` ${config.readCurrency}`}));
      } else {
        let songuyen = this.DocTienBangChu(strTachPhanSauDauPhay[0], opNguyen, {read: ` ${config.readCurrency}`});
        let sothapphan = this.DocTienBangChu(strTachPhanSauDauPhay[1], opThapphan, {read: ` ${config.readDecimal}`});
        return songuyen + optionAnd + sothapphan.substring(0, 1).toLowerCase() + sothapphan.substring(1);
      }
    }

    let afterFix = config.read || this.changeType(type);
    let lan = 0;
    let i = 0;
    let so = 0;
    let KetQua = "";
    let tmp = "";
    let ViTri = [];
    let preFix = "";
    if (SoTien < 0)
      preFix = "âm ";
    if (SoTien == 0) return "Không" + afterFix;
    if (SoTien > 0) {
      so = SoTien;
    } else {
      so = -SoTien;
    }
    if (SoTien > 8999999999999999) {
      return "Số quá lớn!";
    }
    ViTri[5] = Math.floor(so / 1000000000000000);
    if (isNaN(ViTri[5]))
      ViTri[5] = "0";
    so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
    ViTri[4] = Math.floor(so / 1000000000000);
    if (isNaN(ViTri[4]))
      ViTri[4] = "0";
    so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
    ViTri[3] = Math.floor(so / 1000000000);
    if (isNaN(ViTri[3]))
      ViTri[3] = "0";
    so = so - parseFloat(ViTri[3].toString()) * 1000000000;
    ViTri[2] = parseInt(String(so / 1000000));
    if (isNaN(ViTri[2]))
      ViTri[2] = "0";
    ViTri[1] = parseInt(String((so % 1000000) / 1000));
    if (isNaN(ViTri[1]))
      ViTri[1] = "0";
    ViTri[0] = parseInt(String(so % 1000));
    if (isNaN(ViTri[0]))
      ViTri[0] = "0";
    if (ViTri[5] > 0) {
      lan = 5;
    } else if (ViTri[4] > 0) {
      lan = 4;
    } else if (ViTri[3] > 0) {
      lan = 3;
    } else if (ViTri[2] > 0) {
      lan = 2;
    } else if (ViTri[1] > 0) {
      lan = 1;
    } else {
      lan = 0;
    }
    for (i = lan; i >= 0; i--) {
      tmp = this.DocSo3ChuSo(ViTri[i]);
      if (i < lan)
        if (ViTri[i] > 0 && ViTri[i] < 100)
          if (ViTri[i] > 0 && ViTri[i] < 10)
            tmp = " không trăm linh" + tmp;
          else
            tmp = " không trăm" + tmp;

      KetQua += tmp;
      if (i >= 4) {
        if (ViTri[i] > 0 && ViTri[i - 1] == 0)
          KetQua += this.Tien[i];
        else
          KetQua += Tien4[i];
      } else {
        if (ViTri[i] > 0) KetQua += this.Tien[i];
      }
    }
    if (KetQua.substring(KetQua.length - 1) == ',') {
      KetQua = KetQua.substring(0, KetQua.length - 1);
    }
    KetQua = preFix + KetQua.trim() + afterFix;
    return KetQua.substring(0, 1).toUpperCase() + KetQua.substring(1);
  }

}